/*******************************************
 * ダイアログの処理関数群です。
 *******************************************/

/**
 * 削除処理
 * @param {*} modalTitle モーダルのタイトル,  modalBody モーダルの本文,  callbackコールバック関数
 * @returns
 */
export const commonDialog = (modalTitle, modalBody, callback,
    modalCaution = null, modalAddBody = null, modalAddCaution = null, modalAddAfterCaution = null, modalBeforeHtmlText = null, modalAfterHtmlText = null) =>
{
    $('#modal2').find('.modal-title').text(modalTitle);
    $('#modal2').find('.modal-body .massage').text(modalBody);
    $('#modal2').find('.modal-body .caution').text(modalCaution);
    $('#modal2').find('.modal-body .add_massage').text(modalAddBody);
    $('#modal2').find('.modal-body .add_caution').text(modalAddCaution);
    $('#modal2').find('.modal-body .add_after_caution').text(modalAddAfterCaution);
    $('#modal2').find('.modal-body .before_html_text').html(modalBeforeHtmlText);
    $('#modal2').find('.modal-body .after_html_text').html(modalAfterHtmlText);
    $('#modal2').modal('show');

    $('#modal2_ok_btn').off();
    $('#modal2_ok_btn').on('click', callback);
    return false;
};

export const noDonationDialog = (modalTitle, modalBody, callback,
    modalCaution = null, modalAddBody = null, modalAddCaution = null, modalAddAfterCaution = null,) =>
{
    $('#modal_no_donation').find('.modal-title').text(modalTitle);
    $('#modal_no_donation').find('.modal-body .massage').text(modalBody);
    $('#modal_no_donation').find('.modal-body .caution').text(modalCaution);
    $('#modal_no_donation').find('.modal-body .add_massage').text(modalAddBody);
    $('#modal_no_donation').find('.modal-body .add_caution').text(modalAddCaution);
    $('#modal_no_donation').find('.modal-body .add_after_caution').text(modalAddAfterCaution);
    $('#modal_no_donation').modal('show');

    $('#modal_no_donation').off('hidden.bs.modal');
    $('#modal_no_donation').on('hidden.bs.modal', callback);
    // $('#modal2_ok_btn').off('cilck');
    // $('#modal2_ok_btn').on('click', callback);
    return false;
};


/**
 * 削除処理
 * @param {*} modalTitle モーダルのタイトル,  modalBody モーダルの本文,  callbackコールバック関数
 * @returns
 */
export const commonValidationDialog = (modalTitle, modalBody, callback) =>
{
    $('#modal_validate').find('.modal-title').text(modalTitle);
    $('#modal_validate').find('.modal-body').text(modalBody);
    $('#modal_validate').modal('show');

    return false;
};

/**
 * 一括削除処理
 * @param {*} modalTitle モーダルのタイトル,  modalBodySuccess モーダルの削除対象あり時の文言,  modalBodyError モーダルの削除対象なし時の文言
 * @returns
 */
export const commonDeleteAll = (modalTitle, modalBodySuccess, modalBodyError, modalCaution = null, modalAddBody = null, modalAddCaution = null, modalAddAfterCaution = null, modalBeforeHtmlText = null, modalAfterHtmlText = null) =>
{
    var cnt = 0;        // チェック済チェックボックス数
    // var ids = '';       // チェック済チェックボックスのリスト
    // var flg = false;    // 確認用ダイアログの戻り値

    // チェックされたチェックボックスが0件の場合、アラートを表示
    if ($('#SearchTable').dataTable.$('.select_base').serialize() == "")
    {
        //モーダル情報を設定し、モーダルを表示
        $('#modal1').find('.modal-title').text(modalTitle);
        $('#modal1').find('.modal-body .massage').text(modalBodyError);
        $('#modal1').modal('show');
        //$('#myToast').toast({animation:true, autohide: true, delay:3000});
        //$('#myToast').toast('show');

        return false;
    }

    // チェックされたチェックボックスの数と場所を特定
    $('#SearchTable').dataTable.$('.check_group').each(function ()
    {
        if ($(this).prop('checked'))
        {
            cnt++;
            // ids += $(this).val()+',';
        }
    });

    // 「件」を対象に前後分け
    var arrayBodySplit = new String(modalBodySuccess).split('件');
    // 件数と「件」を組み合わせる
    var strCnt = cnt + '件';
    // 整えた文言を保存
    modalBodySuccess = arrayBodySplit[0] + strCnt + arrayBodySplit[1];
    // 削除前の確認ダイアログ出力
    // flg = confirm(modalBodySuccess);
    // if (flg == false){
    //     return false;
    // }

    $('#modal2').find('.modal-title').text(modalTitle);
    $('#modal2').find('.modal-body .massage').text(modalBodySuccess);
    $('#modal2').find('.modal-body .caution').text(modalCaution);
    $('#modal2').find('.modal-body .add_massage').text(modalAddBody);
    $('#modal2').find('.modal-body .add_caution').text(modalAddCaution);
    $('#modal2').find('.modal-body .add_after_caution').text(modalAddAfterCaution);
    $('#modal2').find('.modal-body .before_html_text').html(modalBeforeHtmlText);
    $('#modal2').find('.modal-body .after_html_text').html(modalAfterHtmlText);
    $('#modal2').modal('show');

    return false;
};


/**
 * 一括復元処理
 * @param {*} modalTitle モーダルのタイトル,  modalBodySuccess モーダルの復元対象あり時の文言,  modalBodyError モーダルの復元対象なし時の文言
 * @returns
 */
export const commonRepairAll = (modalTitle, modalBodySuccess, modalBodyError) =>
{
    var cnt = 0;        // チェック済チェックボックス数
    // var ids = '';       // チェック済チェックボックスのリスト
    // var flg = false;    // 確認用ダイアログの戻り値

    // チェックされたチェックボックスが0件の場合、アラートを表示
    if ($('#SearchTable').dataTable.$('.select_base').serialize() == "")
    {
        //モーダル情報を設定し、モーダルを表示
        $('#modal1').find('.modal-title').text(modalTitle);
        $('#modal1').find('.modal-body').text(modalBodyError);
        $('#modal1').modal('show');
        return false;
    }

    // チェックされたチェックボックスの数と場所を特定
    $('#SearchTable').dataTable.$('.check_group').each(function ()
    {
        if ($(this).prop('checked'))
        {
            cnt++;
            // ids += $(this).val()+',';
        }
    });

    // 「件」を対象に前後分け
    var arrayBodySplit = new String(modalBodySuccess).split('件');
    // 件数と「件」を組み合わせる
    var strCnt = cnt + '件';
    // 整えた文言を保存
    modalBodySuccess = arrayBodySplit[0] + strCnt + arrayBodySplit[1];
    // 復元前の確認ダイアログ出力
    // flg = confirm(modalBodySuccess);
    // if (flg == false){
    //     return false;
    // }
    $('#modal2').find('.modal-title').text(modalTitle);
    $('#modal2').find('.modal-body').text(modalBodySuccess);
    $('#modal2').modal('show');

    return false;
};

/**
 * 一括休止処理
 * @param {*} modalTitle モーダルのタイトル,  modalBodySuccess モーダルの休止対象あり時の文言,  modalBodyError モーダルの休止対象なし時の文言
 * @returns
 */
export const commonPausedAll = (modalTitle, modalBodySuccess, modalBodyError) =>
{
    var cnt = 0;        // チェック済チェックボックス数

    // チェックされたチェックボックスが0件の場合、アラートを表示
    if ($('#SearchTable').dataTable.$('.select_base').serialize() == "")
    {
        //モーダル情報を設定し、モーダルを表示
        $('#modal1').find('.modal-title').text(modalTitle);
        $('#modal1').find('.modal-body').text(modalBodyError);
        $('#modal1').modal('show');

        return false;
    }

    // チェックされたチェックボックスの数と場所を特定
    $('#SearchTable').dataTable.$('.check_group').each(function ()
    {
        if ($(this).prop('checked'))
        {
            cnt++;
            // ids += $(this).val()+',';
        }
    });

    // 「件」を対象に前後分け
    var arrayBodySplit = new String(modalBodySuccess).split('件');
    // 件数と「件」を組み合わせる
    var strCnt = cnt + '件';
    // 整えた文言を保存
    modalBodySuccess = arrayBodySplit[0] + strCnt + arrayBodySplit[1];

    $('#modal2').find('.modal-title').text(modalTitle);
    $('#modal2').find('.modal-body').text(modalBodySuccess);
    $('#modal2').modal('show');

    return false;
};

/**
 * 一括受取処理
 * @param {*} modalTitle モーダルのタイトル,  modalBodySuccess モーダルの復元対象あり時の文言,  modalBodyError モーダルの復元対象なし時の文言
 * @returns
 */
export const commonCollectiveReceipt = (modalTitle, modalBodySuccess, modalBodyError, modalCaution = null) =>
{
    $('#modal1').find('.modal-body .caution').text(modalCaution);
    $('#modal2').find('.modal-body .caution').text(modalCaution);

    var cnt = 0;        // チェック済チェックボックス数

    // チェックされたチェックボックスが0件の場合、アラートを表示
    if ($('#SearchTable').dataTable.$('.select_base').serialize() == "")
    {
        //モーダル情報を設定し、モーダルを表示
        $('#modal1').find('.modal-title').text(modalTitle);
        $('#modal1').find('.modal-body .massage').text(modalBodyError);
        $('#modal1').modal('show');
        return false;
    }

    // チェックされたチェックボックスの数と場所を特定
    $('#SearchTable').dataTable.$('.check_group').each(function ()
    {
        if ($(this).prop('checked'))
        {
            cnt++;
        }
    });

    // 「件」を対象に前後分け
    var arrayBodySplit = new String(modalBodySuccess).split('件');
    // 件数と「件」を組み合わせる
    var strCnt = cnt + '件';
    // 整えた文言を保存
    modalBodySuccess = arrayBodySplit[0] + strCnt + arrayBodySplit[1];

    $('#modal2').find('.modal-title').text(modalTitle);
    $('#modal2').find('.modal-body .massage').text(modalBodySuccess);
    $('#modal2').modal('show');

    return false;
};

/**
 * こども食堂マスタ_履歴登録確認処理
 * @param {*} modalTitle モーダルのタイトル,  modalBody モーダルの本文,  callback1 コールバック関数1, callback2 コールバック関数2
 * @returns
 */
export const historyCheckDialog = (modalTitle, modalBody, callback1, callback2) =>
{
    $('#modal_history').find('.modal-title').text(modalTitle);
    $('#modal_history').find('.modal-body-msg').text(modalBody);
    $('#modal_history').modal('show');

    // 「履歴情報を残して登録」ボタンでコールバック関数1を実行する
    $('#modal_history_regist_ok_btn').off('cilck');
    $('#modal_history_regist_ok_btn').on('click', callback1);

    // 「履歴情報を残さず登録」ボタンでコールバック関数2を実行する
    $('#modal_history_regist_ng_btn').off('cilck');
    $('#modal_history_regist_ng_btn').on('click', callback2);
    return false;
};

/**
 * 代行操作処理
 * @param {*} modalTitle モーダルのタイトル,  modalBody モーダルの本文,  callbackコールバック関数
 * @returns
 */
export const insteadDialog = (modalTitle, modalBody, callback, modalCaution = null, modalAddBody = null, modalAddCaution = null,) =>
{
    $('#select_instead_user_modal').find('.modal-title').text(modalTitle);
    $('#select_instead_user_modal').find('.modal-body .massage').text(modalBody);
    $('#select_instead_user_modal').find('.modal-body .caution').text(modalCaution);
    $('#select_instead_user_modal').find('.modal-body .add_massage').text(modalAddBody);
    $('#select_instead_user_modal').find('.modal-body .add_caution').text(modalAddCaution);
    $('#select_instead_user_modal').modal('show');

    $('#modal_ok_btn').off('cilck');
    $('#modal_ok_btn').on('click', callback);
    return false;
};


// 承認状況詳細ダイアログを開く
export const showApprovalStatusDetailDialog = (approval_id) =>
{
    // 承認IDを挿入
    $('#approval_status_detail_modal').find('#approval_id').val(approval_id);
    // ダイアログを開く
    $('#approval_status_detail_modal').modal('show');

    return false;
}
